<script lang="ts">
export default {
    name: 'IconInfoBlogPost',
    props: {
        /**
         * Width
         */
        width: {
            type: String,
            default: '32px',
            required: false,
        },
        /**
         * Height
         */
        height: {
            type: String,
            default: '32px',
            required: false,
        },
    },
};
</script>

<template>
    <svg
        :style="{
            height: height,
            width: width,
        }"
        viewBox="0 0 32 32"
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg">
        <path
            d="M26.4643 5H5.54015C5.24351 5 5 5.24923 5 5.55283V24.0046C5 24.3082 5.24351 24.5575 5.54015 24.5575H19.3051L19.7213 26.4697C19.7523 26.6193 19.8718 26.7325 20.0179 26.7643C20.164 26.7914 20.3146 26.7325 20.3987 26.6057L21.2399 25.3505L22.5504 26.8775C22.6257 26.9636 22.7275 27.009 22.8338 27.009C22.9179 27.009 22.9976 26.9818 23.0684 26.9274L24.3701 25.8716C24.4498 25.8081 24.4985 25.713 24.5118 25.6088C24.5251 25.5045 24.4896 25.4003 24.4277 25.3233L23.8034 24.562H26.4599C26.7565 24.562 27 24.3128 27 24.0092V5.55283C27 5.24923 26.7565 5 26.4599 5H26.4643ZM26.2518 5.77034V8.27619H5.75267V5.77034H26.2518ZM18.7649 19.0564C18.6365 18.9703 18.4727 18.9748 18.3443 19.0609C18.2159 19.1515 18.1584 19.3101 18.1894 19.4597L18.4639 20.7103H8.31616V18.3449H23.2987V20.7103H21.231L18.7649 19.0564V19.0564ZM22.8869 26.0891L21.4923 24.4668C21.4214 24.3853 21.3152 24.3354 21.2089 24.3354C21.2 24.3354 21.1956 24.3354 21.1868 24.3354C21.0716 24.3445 20.9654 24.4034 20.899 24.5031L20.2703 25.4366L19.128 20.2209L23.4315 23.112L22.5238 23.3204C22.3955 23.3476 22.2936 23.4473 22.2493 23.5742C22.2051 23.701 22.2316 23.8415 22.3158 23.9457L23.5997 25.5091L22.8825 26.0936L22.8869 26.0891ZM23.9451 23.7826L24.4675 23.6648C24.6136 23.6331 24.7287 23.5107 24.7553 23.3567C24.7818 23.2026 24.7199 23.0485 24.5915 22.967L22.3777 21.4807H23.675C23.8831 21.4807 24.0513 21.3085 24.0513 21.0955V17.9598C24.0513 17.7468 23.8831 17.5746 23.675 17.5746H7.93983C7.73174 17.5746 7.56349 17.7468 7.56349 17.9598V21.0955C7.56349 21.3085 7.73174 21.4807 7.93983 21.4807H18.6321L19.1368 23.7871H5.75267V9.04653H26.2518V23.7871H23.9406L23.9451 23.7826Z" />
        <path
            d="M9.75506 7.39704C9.96758 7.39704 10.1402 7.22032 10.1402 7.00281C10.1402 6.78531 9.96758 6.60858 9.75506 6.60858C9.54254 6.60858 9.36987 6.78531 9.36987 7.00281C9.36987 7.22032 9.54254 7.39704 9.75506 7.39704Z" />
        <path
            d="M8.29403 7.39704C8.50655 7.39704 8.67922 7.22032 8.67922 7.00281C8.67922 6.78531 8.50655 6.60858 8.29403 6.60858C8.08151 6.60858 7.90884 6.78531 7.90884 7.00281C7.90884 7.22032 8.08151 7.39704 8.29403 7.39704Z" />
        <path
            d="M6.83297 7.39704C7.04549 7.39704 7.21816 7.22032 7.21816 7.00281C7.21816 6.78531 7.04549 6.60858 6.83297 6.60858C6.62045 6.60858 6.44778 6.78531 6.44778 7.00281C6.44778 7.22032 6.62045 7.39704 6.83297 7.39704Z" />
        <path
            d="M23.4757 11.4255H8.03722C7.82913 11.4255 7.66089 11.5977 7.66089 11.8107C7.66089 12.0237 7.82913 12.1959 8.03722 12.1959H23.4757C23.6838 12.1959 23.8521 12.0237 23.8521 11.8107C23.8521 11.5977 23.6838 11.4255 23.4757 11.4255Z" />
        <path
            d="M23.4757 14.5023H8.03722C7.82913 14.5023 7.66089 14.6745 7.66089 14.8875C7.66089 15.1005 7.82913 15.2727 8.03722 15.2727H23.4757C23.6838 15.2727 23.8521 15.1005 23.8521 14.8875C23.8521 14.6745 23.6838 14.5023 23.4757 14.5023Z" />
    </svg>
</template>
